module.exports = __webpack_public_path__ + "static/img/14001009.928f203e.png";